<template>
  <span>
    <el-dialog
      v-if="fileId"
      title="预览"
      append-to-body
      width="70%"
      destroy-on-close
      :visible="visible"
      @close="visible = false"
    >
      <img v-if="type === 'img'" class="preview-image" :src="fileUrl" alt="" />
      <video
        v-if="type === 'video'"
        autoplay
        class="preview-video"
        width="100%"
        controls
        :src="fileUrl"
        alt=""
      />
      <template v-if="showFrame">
        <iframe ref="iframe" width="100%" :src="fileUrl" style="height: 60vh" />
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">确定</el-button>
      </span>
    </el-dialog>
  </span>
</template>

<script>
const imgReg = /(.*)\.(jpg|png|jepg|gif|webp|jpeg)$/;
const videoReg = /(.*)\.(mp4|mkv|ogg|webm)$/;
const officeReg = /(.*)\.(doc|xls|xlsx|docx|ppt|pptx)$/;
const pdfTxtReg = /(.*)\.(pdf|txt)$/;
export default {
  name: "PreviewByFileId",
  props: {
    fileId: {
      type: [Number, String],
      required: true
    },
    // 模态框状态
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: this.value,
      fileUrl: "",
      fileName: "",
      showFrame: false,
      formParams: {
        token: workFlowConfig.token,
        projectType: workFlowConfig.projectType,
        projectId: workFlowConfig.projectId
      }
    };
  },
  computed: {
    type() {
      if (!this.fileName) return "other";
      if (imgReg.test(this.fileName.toLowerCase())) {
        return "img";
      } else if (videoReg.test(this.fileName.toLowerCase())) {
        return "video";
      } else if (officeReg.test(this.fileName.toLowerCase())) {
        return "office";
      } else if (pdfTxtReg.test(this.fileName.toLowerCase())) {
        return "pdfTxt";
      } else {
        return "other";
      }
    },
    filePreviewApi() {
      return workFlowConfig.configApi.filePreviewApi;
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.visible = val;
      }
    },
    visible(val) {
      if (!val) {
        this.fileUrl = "";
        this.showFrame = false;
        this.$emit("change", val);
        return;
      }
      this.getFileList();
      let params = Object.assign({}, this.formParams, {
        type: "noHold"
      });
      this.$axios(`${this.filePreviewApi}${this.fileId}`, params).then(res => {
        if (
          (this.type === "pdfTxt" || this.type === "office") &&
          res.data.code === 500
        ) {
          this.$message.error("文件内容有误，无法预览");
          return;
        }
        let fileUrl = `${this.filePreviewApi}${this.fileId}`;
        this.fileUrl = fileUrl;
        if (this.type === "img" || this.type === "video") {
          this.showFrame = false;
          return;
        }
        this.showFrame = true;
      });
    }
  },
  created() {
    this.getFileList();
  },
  methods: {
    async getFileList() {
      if (!this.fileId) {
        return;
      }
      let result = await this.$axios.get(
        workFlowConfig.configApi.fileByIdApi + this.fileId,
        this.formParams
      );
      let datas = result.data;
      this.fileUrl = datas.fileUrl;
      this.fileName = datas.fileName;
    }
  }
};
</script>

<style scoped lang="less">
.preview-image {
  display: block;
  margin: 0 auto;
  max-width: 100%;
}
a {
  font-size: 14px;
}
.disabled {
  color: #333;
  cursor: not-allowed;
}
/deep/ .el-dialog__header {
  border-bottom: 1px #eeeeee solid;
}
</style>
